import { useOutletContext } from 'react-router-dom'

import type { TrainingsSessionFile } from 'generated/resources/graphql'

export const useSessionFilesContext = () =>
  useOutletContext<{ sessionFiles: TrainingsSessionFile[] }>()

export type SessionFile = TrainingsSessionFile
